export class LocalStorage {
  static get = (key: string) => {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.error(`ERROR:get`, key, e);
    }

    return null;
  };

  static remove = (key: string) => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error(`ERROR:remove`, key, e);
    }
  };

  static set = (key: string, value: string) => {
    try {
      return localStorage.setItem(key, value);
    } catch (e) {
      console.error(`ERROR:set`, key, e);
    }
  };
}
